import settings from '../settings';
import $ from 'jquery';

export default class MyChannels {

  constructor() {
    this.init();
  }

  init() {
    var that = this;
    $(".archived-channel").hide();

    $('#channel-table-search').keyup(function () {
      that.searchTable();
    });

    $('#table-filter.status').change(function () {
      that.statusFilter();
    });

    $('#table-filter.creator').change(function () {
      that.creatorFilter();
    });

    $('.member-toggle').click(function () {
      that.toggleUpload();
    });

  }

  searchTable() {
    // Declare variables
    var input, filter, table, tr, td, i, selected, selectedClass;
    input = document.getElementById("channel-table-search");
    filter = input.value.toUpperCase();
    table = document.getElementById("channel-table");
    tr = table.getElementsByTagName("tr");
    selected = $('#table-filter').val();

    if (selected == 'active') {
      selectedClass = 'active-channel';
    } else if (selected == 'archived') {
      selectedClass = 'archived-channel';
    } else {
      selectedClass = selected;
    }

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      if (tr[i].classList.contains(selectedClass) || selectedClass == 'all') {
        td = tr[i].getElementsByTagName("td")[0];
        if (td) {
          var span = td.getElementsByTagName('span')[0];

          if (span) {
            if (span.innerText.toUpperCase().indexOf(filter) > -1) {
              tr[i].style.display = "";
            } else {
              tr[i].style.display = "none";
            }
          }
        }
      }
    }
  }

  statusFilter() {
    var selected = $('#table-filter.status').val();
    if (selected === "active") {
      $(".active-channel").show();
      $(".archived-channel").hide();
      $("#channel-table-name").html("Active Channels");
      return;
    } else {
      $(".active-channel").hide();
      $(".archived-channel").show();
      $("#channel-table-name").html("Archived Channels");
      return;
    }
  }

  creatorFilter() {
    var filter = $('#table-filter.creator').val();
    if (filter == 'all') {
      $("#channel-table tr").show();
    } else {
      $("#channel-table tbody tr").hide();
      $("#channel-table tbody tr." + filter).show();
      return;
    }
  }

  toggleUpload() {
    event.preventDefault();
    $("#add-members").toggle();
    $("#upload-members").toggle();
  }

}
